<!--
 * @description: 
 * @author: Jason Wong
 * @since: 2024-12-16 17:24:52
-->
<template>
  <div></div>
</template>

<script>
export default {
  mounted() {
    console.log("!resolve -> mounted:",this.$router.resolve({ name: "userManager" }).href);
    this.$router.replace({ name: "userManager" });
  },
};
</script>